import {createAsyncThunk } from "@reduxjs/toolkit";
import { extraEntityReducersFunction } from "../entitiesType";
import { OrganizationNamesState } from "./types";
import apiCalls from "../../../PowerShadesAPIFunctions";
import { createSelector } from "reselect";
import store, { AppState, UsePortalSelector } from "../..";


export const initialOrganizationNamesState: () => OrganizationNamesState = () => ({
    dealer: {},
    distributor: {},
    representative: {},
    distributor_location: {}
});

export const selectOrganizationName = (state: AppState) => createSelector(
    (id: number, type: 'dealer' | 'distributor' | 'representative' | 'distributor_location') => id === 0 ? 'Unknown' : state.entity.organizationNames[type][id],
    (name) => name || ''
);

export const useEntityName = (id: number, type: 'dealer' | 'distributor' | 'representative' | 'distributor_location') => {
    
    const name = UsePortalSelector(selectOrganizationName)(id, type);

    if (!name && id > 0 && name !== 'Loading...') {
        // Trigger loading the name if it doesn't exist
        store.dispatch(loadOrganizationName({ id, type }));
    }

    return name === 'Unknown' ? '' : name;
};

const loadOrganizationName = createAsyncThunk<string, { id: number, type: 'dealer' | 'distributor' | 'representative' | 'distributor_location' }>(
    'organizations/loadOrganizationName',
    async ({ id, type }, { rejectWithValue }) => {
        try {
            // Simulate an API call to fetch the organization name
            const response = await apiCalls.getEntityName(type, id);
            if (response.error) {
                throw new Error(response.error);
            }
            return response.data.name;
        } catch (error) {
            return rejectWithValue((error as Error)?.message);
        }
    }
);

export const organizationNamesBuilder: extraEntityReducersFunction = (_builder) => {
    _builder
        .addCase(loadOrganizationName.fulfilled, (state, action) => {
            const { id, type } = action.meta.arg;
            state.organizationNames[type][id] = action.payload;
        })
        .addCase(loadOrganizationName.pending, (state, action) => {
            const { id, type } = action.meta.arg;
            state.organizationNames[type][id] = 'Loading...';
        })
        .addCase(loadOrganizationName.rejected, (_, action) => {
            console.error("Failed to load organization name:", action.payload);
        });
}

 